const iconTypes = {
  ANIMATED: 'animated',
  STATIC: 'static',
  ANIMATED_AND_STATIC: 'animated-and-static',
};

export default iconTypes;
